import { Categories } from "../models/categories";

const firstCatId = "firstCat";

const initialState: Categories = {
  nowTabCategory: firstCatId,
  order: [firstCatId],
  list: {
    [firstCatId]: {
      name: "今年やりたい事"
    }
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "ADD_CATEGORY":
      return {
        ...state,
        nowTabCategory: action.id,
        order: [...state.order, action.id],
        list: {
          ...state.list,
          [action.id]: { name: action.categoryName }
        }
      };
    case "RENAME_CATEGORY":
      return {
        ...state,
        list: {
          ...state.list,
          [action.id]: { name: action.categoryName }
        }
      };
    case "RESTORE_CATEGORY":
      const newState = {
        ...state,
        list: action.list,
        order: action.order
      };
      if (!action.list[state.nowTabCategory]) {
        newState.nowTabCategory = action.order[0];
      }
      return newState;
    case "REMOVE_CATEGORY":
      delete state.list[action.id];
      const deleteTagOrderIndex = state.order.indexOf(action.id);
      const newOrder = state.order.filter(id => id !== action.id);
      //選択中のカテゴリーだったら消すカテゴリに近いタブを選択状態にする
      let nowTabCategory = state.nowTabCategory;
      if (state.nowTabCategory === action.id) {
        if (deleteTagOrderIndex > newOrder.length - 1) {
          nowTabCategory = newOrder[newOrder.length - 1];
        } else {
          nowTabCategory = newOrder[deleteTagOrderIndex];
        }
      }
      return {
        ...state,
        order: newOrder,
        nowTabCategory,
        list: {
          ...state.list
        }
      };
    case "SET_TAB_CATEGORY":
      return {
        ...state,
        nowTabCategory: action.tabCategory
      };
    case "SET_NEW_ORDER_CATEGORY":
      return {
        ...state,
        order: action.newOrder,
        nowTabCategory: action.newOrder[0]
      };
    case "DELETE_ALL_CATEGORY":
      return initialState;
    default:
      return state;
  }
}
